import React, { useEffect, useMemo, useState } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { useFormik } from 'formik';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import SecondaryButton from '../../components/infrastructure/Buttons/SecondaryButton';
import moment from 'moment';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { exportCsv } from '../../utils/Utils';
import { ClipLoader } from 'react-spinners';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';

const ExportProductModal = ({
    openExportProductModal,
    setOpenExportProductModal,
    totalDocs,
    setTotalDocs,
    calculateExportButtons,
    getIndiaMartLeads,
    gap,
}) => {
    const [ productDownloader, setProductDownloader] = useState(null)
    const formik = useFormik({
        initialValues: {
            from: '',
            to: '',
        },
        onSubmit: async (values) => {
            console.log('value', values);
            const query = {};
            if (values.from && values.to) {
                query['leadCreatedTime'] = {
                    $gte: moment(values.from).startOf('day').valueOf(),
                    $lte: moment(values.to).endOf('day').valueOf(),
                };
            }
            const result = await getIndiaMartLeads(query);
            setTotalDocs(result?.totalDocs || 0);
          
        },
    });
    // const calculateExportButtons = (totalDocs, gap) => {
    //     let result = [];
    //     if (totalDocs < gap) {
    //         result = [1, totalDocs];
    //         console.log('result if', result);
    //         return result;
    //     }
    //     for (let i = 0; i <= Math.floor(totalDocs / gap); i++) {
    //         result.push([i * gap + 1, Math.min((i + 1) * gap, totalDocs)]);
    //     }
    //     console.log('result for loop', result);
    //     return result;
    // };
    // const BUTTON_GAP = 100;
    const exportButtonRanges = useMemo(() => {
        if (totalDocs > 0) {
            return calculateExportButtons(totalDocs, gap);
        }
        return [];
    }, [totalDocs, gap]);

    

    return (
        <ModalBasic
            modalOpen={openExportProductModal}
            setModalOpen={setOpenExportProductModal}
            title={'Export Products'}
        >
            <div className="p-4">
                <form
                    className="flex flex-col gap-4"
                    onSubmit={formik.handleSubmit}
                >
                    <div className="flex flex-col md:flex-row items-center gap-2">
                        <FormikInputDateGroup
                            formik={formik}
                            name="from"
                            label="From"
                        />
                        <FormikInputDateGroup
                            formik={formik}
                            name="to"
                            label="To"
                        />
                    </div>
                    <div className="my-4 flex flex-row items-center gap-4">
                        <PrimaryButton type="submit">Filter</PrimaryButton>
                        <DangerButton type='button'
                            onClick={async(e)=>{
                                e.stopPropagation();
                                formik.setFieldValue('from', null)
                                formik.setFieldValue('to', null)
                                await getIndiaMartLeads()
                            }}
                        >Clear</DangerButton>
                    </div>
                    <div className="flex flex-wraP items-center gap-4">
                        {totalDocs > 0 &&
                            exportButtonRanges.map(
                                (btn, i) => (
                                    <SecondaryButton type="button" key={i}
                                        onClick={async(e)=>{
                                            e.stopPropagation();
                                            try {
                                                setProductDownloader(i)
                                                const query = {
                                                limit : Math.min(btn[1], gap),
                                                page : i + 1
                                                }
                                                const string = QueryString.stringify(query);
                                                const resp = await authAxiosInstance.get(
                                                    `/indiamart/getLeads?${string}`
                                                )
                                                console.log('resp', resp?.data?.data)
                                                const fetchLeads = resp?.data?.data?.docs;
                                                const data = fetchLeads?.map((ele, index)=>{
                                                    return {
                                                        "Sr.No" : `${ Number(btn[0] + index)}`,
                                                        'Unique Id' : ele.uniqueid,
                                                        'Type' : ele.type,
                                                        'Name' : ele.name,
                                                        'Time': ele.time, 
                                                        'Mobile':ele.mobile, 
                                                        'Phone':ele.phone, 
                                                        'Email':ele.email, 
                                                        'Subject':ele.subject, 
                                                        'Company':ele.company, 
                                                        'Address':ele.address, 
                                                        'City':ele.city, 
                                                        'Pincode':ele.pincode, 
                                                        'Country ISO':ele.country_iso, 
                                                        'Product Name':ele.productName, 
                                                        'M Cat Name':ele.mcat_name, 
                                                        'Call Duration':ele.callDuration, 
                                                        'Receiver Mobile':ele.receiver_mobile, 
                                                        'Receiver Catalog':ele.receiver_catalog, 
                                                        'Message':ele.message, 
                                                        'Mobile Alt':ele.mobileAlt, 
                                                        'Phone Alt':ele.phoneAlt, 
                                                        'Email Alt':ele.emailAlt, 
                                                    }
                                                })
                                                
                                                exportCsv(data)
                                            } catch (error) {
                                                console.log('Error',error)
                                            } finally {
                                                setProductDownloader(null)
                                            }
                                            
                                        }}
                                    >
                                        { productDownloader === i ? (<ClipLoader size={18}/>) : `${btn[0]} - ${btn[1]}`}
                                    </SecondaryButton>
                                )
                            )}
                    </div>
                </form>
            </div>
        </ModalBasic>
    );
};
export default ExportProductModal;
